import { Link } from 'react-router-dom';

import styles from './PortalComponents.module.css';

export function BackLink({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <p className={styles.backLinkRow}>
      <Link className={styles.backLink} to={to}>
        {children}
      </Link>
    </p>
  );
}
